<div class="cover">
  <div class="mobile-images">
    <img
      loading="lazy"
      class="mobile-circles"
      src="/assets/images/home/cover/mobile-circles.svg"
      alt="circles"
    />
    <img
      loading="lazy"
      class="tablet-circles"
      src="/assets/images/home/cover/tablet-circles.svg"
      alt="circles"
    />
    <img
      class="mobile-orders-and-users"
      [src]="imgLink"
      alt="orders and users"
    />
  </div>
  <div class="container d-flex">
    <div class="cover-data">
      <h1>{{ "shop-with-madfu-and-pay-later" | translate }}</h1>
      <p class="subtitle">{{ "shop-with-peace-of-mind" | translate }}</p>

      <div class="download-app-section">
        <img
          loading="lazy"
          src="/assets/images/home/cover/scan-me-qr-code.svg"
          alt="qr code"
          class="qr-code"
        />

        <img
          loading="lazy"
          src="/assets/images/home/cover/scan-me-arrow.svg"
          alt="arrow"
          class="scan-me-arrow"
        />
        <div>
          <p class="scan-me">{{ "scan-me" | translate }}</p>
          <a
            href="https://onelink.to/ym7r5c"
            target="_blank"
            class="be-partner-button"
          >
            {{ "download-the-app" | translate }}
          </a>
        </div>
      </div>

      <ul class="features">
        <li>
          <img
            loading="lazy"
            src="/assets/images/home/cover/flexible-payment-options.svg"
            alt="arrow"
            class="scan-me-arrow"
          />
          {{ "flexible-payment-options" | translate }}
        </li>
        <li>
          <img
            loading="lazy"
            src="/assets/images/home/cover/shariaa-compliant.svg"
            alt="arrow"
            class="scan-me-arrow"
          />
          {{ "hundred-shariaa-compliant" | translate }}
        </li>
        <li>
          <img
            loading="lazy"
            src="/assets/images/home/cover/stores.svg"
            alt="arrow"
            class="scan-me-arrow"
          />
          {{ "website-stores-count" | translate }}
        </li>
      </ul>
    </div>

    <img class="orders-and-users" [src]="imgLink" alt="orders and users" />
  </div>

  <img
    loading="lazy"
    class="circles"
    src="/assets/images/home/cover/circles.svg"
    alt="circles"
  />
</div>
